import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

export function setupEnvironment(scene) {
    const rgbeLoader = new RGBELoader();
    rgbeLoader.load('./environmentMaps/snowBackground.hdr', (hdrMap) => {
        hdrMap.mapping = THREE.EquirectangularReflectionMapping;
        scene.environment = hdrMap;
    });

    const loader = new THREE.TextureLoader();
    const backgroundTexture = loader.load('./environmentMaps/snowBackground.webp');
    scene.background = backgroundTexture;
}